// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {ClearCustomerInfo} from './clearinfo';
import {EditLimooPlustDietType} from './editLimooPlustDietType';
import {EditDietType} from './editDietType';
import {EditPhoneNumber} from './editphonenumber';
import {Box } from '@material-ui/core/Box';
import * as React from "react";
export function ManageDietInfo() {
  const [resetKey1, setResetKey1] = React.useState(Date.now()+ Math.floor(Math.random() * (1000 - 1)) + 10);
  const [resetKey2, setResetKey2] = React.useState(Date.now()+ Math.floor(Math.random() * (1000 - 1)) + 10);
  const [resetKey3, setResetKey3] = React.useState(Date.now()+ Math.floor(Math.random() * (1000 - 1)) + 10);
  const [resetKey4, setResetKey4] = React.useState(Date.now()+ Math.floor(Math.random() * (1000 - 1)) + 10);
  const handleResetKeyChange1 = newKey => { setResetKey1(newKey);};
  const handleResetKeyChange2 = newKey => { setResetKey2(newKey);};
  const handleResetKeyChange3 = newKey => { setResetKey3(newKey);};
  const handleResetKeyChange4 = newKey => { setResetKey4(newKey);};
    return (
      <div style={{ display: 'flex', flexDirection:'column', justifyContent: 'space-between', margin: '1rem' }}>
      <ClearCustomerInfo key={resetKey1} resetKey={handleResetKeyChange1} />
      <EditLimooPlustDietType key={resetKey2} resetKey={handleResetKeyChange2} />
      <EditDietType  key={resetKey3} resetKey={handleResetKeyChange3} />
      <EditPhoneNumber key={resetKey4} resetKey={handleResetKeyChange4} />
      </div>
    
    )
}